<div class="app-main__inner">

  <!-- ========== LIST VIEW ========== -->
  <div *ngIf="view === 'list' && !overlayMode" class="bb-list-view">
    <div class="card bb-fill-card">
      <div class="card-header d-flex align-items-center justify-content-between">
        <span class="fw-semibold"><i class="pe-7s-pen me-2 text-primary"></i>Authors List</span>
        <div class="d-flex align-items-center gap-2">
          <span class="badge bg-secondary">{{ records.length }} records</span>
          <button type="button" class="btn btn-primary btn-sm" (click)="addNew()">
            <i class="pe-7s-plus me-1"></i> Add New Author
          </button>
        </div>
      </div>
      <div class="card-body p-0 bb-fill-body">
        <div class="text-center py-5" *ngIf="isListLoading">
          <div class="spinner-border text-primary"></div>
          <p class="mt-2 text-muted">Loading authors...</p>
        </div>
        <vio-table-v2 *ngIf="!isListLoading" [tableData]="records" [tableConfig]="tableConfig"></vio-table-v2>
      </div>
    </div>
  </div>

  <!-- ========== FORM VIEW ========== -->
  <div *ngIf="view === 'form'" class="bb-form-view">
    <div class="bb-form-card">

      <div class="bb-form-header">
        <div class="bb-form-header__title">
          <i class="pe-7s-pen"></i>
          {{ isEditMode ? 'Edit Author' : 'New Author' }}
        </div>
        <button type="button" class="bb-form-header__back" (click)="backToList()">
          <i class="pe-7s-angle-left"></i> {{ overlayMode ? 'Cancel' : 'Back' }}
        </button>
      </div>

      <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
        <div class="bb-form-body">

          <!-- ── Author Names ──────────────────────────────────── -->
          <div class="am-section-label">Author Names</div>
          <div class="row g-2 mb-3">

            <div class="col-md-6">
              <label class="form-label">Author Name <span class="text-danger">*</span></label>
              <input type="text" formControlName="authorName" class="form-control"
                     [class.is-invalid]="isFieldInvalid('authorName')"
                     placeholder="Enter full author name"
                     (blur)="onAuthorNameBlur()" />
              <div class="invalid-feedback">
                <span *ngIf="f['authorName'].errors?.['required']">Author name is required.</span>
                <span *ngIf="f['authorName'].errors?.['minlength']">Must be at least 2 characters.</span>
              </div>
              <div class="bb-dup-panel" *ngIf="nameSuggestions.length > 0">
                <div class="bb-dup-header">
                  <i class="pe-7s-search"></i>
                  <span>{{ nameSuggestions.length }} existing author(s) found</span>
                  <button type="button" class="bb-dup-dismiss" (click)="dismissNameSuggestions()">
                    <i class="pe-7s-close"></i>
                  </button>
                </div>
                <div class="bb-dup-list">
                  <div class="bb-dup-item" *ngFor="let s of nameSuggestions">
                    <span class="bb-dup-id" *ngIf="s.authorCode">{{ s.authorCode }}</span>
                    <span class="bb-dup-name">{{ s.authorName }}</span>
                    <span class="bb-dup-author" *ngIf="s.authorEnglishName">{{ s.authorEnglishName }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <label class="form-label">Author Name (English / Transliterated)</label>
              <input type="text" formControlName="authorEnglishName" class="form-control"
                     placeholder="Auto-filled from Devanagari or type manually" />
              <div class="bb-dup-panel" *ngIf="englishNameSuggestions.length > 0">
                <div class="bb-dup-header">
                  <i class="pe-7s-search"></i>
                  <span>{{ englishNameSuggestions.length }} existing author(s) found</span>
                  <button type="button" class="bb-dup-dismiss" (click)="dismissEnglishNameSuggestions()">
                    <i class="pe-7s-close"></i>
                  </button>
                </div>
                <div class="bb-dup-list">
                  <div class="bb-dup-item" *ngFor="let s of englishNameSuggestions">
                    <span class="bb-dup-id" *ngIf="s.authorCode">{{ s.authorCode }}</span>
                    <span class="bb-dup-name">{{ s.authorName }}</span>
                    <span class="bb-dup-author" *ngIf="s.authorEnglishName">{{ s.authorEnglishName }}</span>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <!-- ── Personal Details ──────────────────────────────── -->
          <div class="am-section-label">Personal Details</div>
          <div class="row g-2 mb-3">
            <div class="col-md-3">
              <label class="form-label">Date of Birth</label>
              <input type="date" formControlName="dateOfBirth" class="form-control" [max]="todayString()" />
              <div class="form-text">Leave blank if unknown.</div>
            </div>
            <div class="col-md-3">
              <label class="form-label">Mobile No.</label>
              <input type="text" formControlName="mobileNo" class="form-control"
                     [class.is-invalid]="isFieldInvalid('mobileNo')"
                     placeholder="10-digit mobile number"
                     maxlength="10" />
              <div class="invalid-feedback">Enter a valid 10-digit number.</div>
            </div>
          </div>

          <!-- ── Address ───────────────────────────────────────── -->
          <div class="am-section-label">Address</div>
          <div class="row g-2">
            <div class="col-12">
              <label class="form-label">Address Line 1</label>
              <input type="text" formControlName="authorAddress1" class="form-control"
                     placeholder="House / flat no., building name" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Address Line 2</label>
              <input type="text" formControlName="authorAddress2" class="form-control"
                     placeholder="Street, area, locality" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Address Line 3</label>
              <input type="text" formControlName="authorAddress3" class="form-control"
                     placeholder="City / district" />
            </div>
            <div class="col-md-2">
              <label class="form-label">Pincode</label>
              <input type="text" formControlName="pincode" class="form-control"
                     [class.is-invalid]="isFieldInvalid('pincode')"
                     placeholder="6 digits"
                     maxlength="6" />
              <div class="invalid-feedback">Enter a valid 6-digit pincode.</div>
            </div>
          </div>

        </div>

        <div class="bb-form-footer">
          <div class="bb-form-footer__msg">
            <span *ngIf="errorMessage" class="text-danger"><i class="pe-7s-close-circle me-1"></i>{{ errorMessage }}</span>
            <span *ngIf="successMessage" class="text-success"><i class="pe-7s-check me-1"></i>{{ successMessage }}</span>
          </div>
          <button type="button" class="bb-btn-reset" *ngIf="!isEditMode" (click)="resetForm()">
            <i class="pe-7s-refresh"></i> Reset
          </button>
          <button type="submit" class="bb-btn-save" [disabled]="isSaving">
            <span *ngIf="!isSaving"><i class="pe-7s-diskette"></i> {{ isEditMode ? 'Update' : 'Save' }}</span>
            <span *ngIf="isSaving" class="d-flex align-items-center gap-1"><span class="spinner-border spinner-border-sm"></span> Saving...</span>
          </button>
        </div>
      </form>

    </div>
  </div>

</div>

<!-- ========== AUTHOR BOOKS MODAL ========== -->
<div class="ab-backdrop" *ngIf="showAuthorBooksModal" (click)="closeAuthorBooksModal()"></div>
<div class="ab-modal" *ngIf="showAuthorBooksModal" (click)="$event.stopPropagation()">

  <div class="ab-modal-header">
    <div class="ab-modal-title">
      <i class="pe-7s-bookmarks me-2 text-primary"></i>Books by {{ selectedAuthorForBooks?.authorName }}
    </div>
    <button type="button" class="ab-close-btn" (click)="closeAuthorBooksModal()">
      <i class="pe-7s-close"></i>
    </button>
  </div>

  <div class="ab-modal-body">

    <div class="text-center py-4" *ngIf="isLoadingAuthorBooks">
      <div class="spinner-border text-primary spinner-border-sm"></div>
      <p class="text-muted small mt-2">Loading books…</p>
    </div>

    <div class="alert alert-danger py-2 px-3 small" *ngIf="authorBooksError">
      <i class="pe-7s-attention me-1"></i>{{ authorBooksError }}
    </div>

    <div class="text-center py-4 text-muted small"
         *ngIf="!isLoadingAuthorBooks && !authorBooksError && authorBooks.length === 0">
      No books found for this author.
    </div>

    <div class="ab-book-list" *ngIf="!isLoadingAuthorBooks && authorBooks.length > 0">
      <p class="text-muted small mb-2">{{ authorBooks.length }} title(s) found</p>

      <div class="ab-book-card" *ngFor="let book of authorBooks">
        <div class="ab-book-header">
          <div class="ab-book-icon"><i class="pe-7s-notebook"></i></div>
          <div class="ab-book-info">
            <div class="ab-book-name">{{ book.bookName }}</div>
            <div class="ab-book-meta">
              <span class="ab-code" *ngIf="book.bookId">{{ book.bookId }}</span>
            </div>
          </div>
          <div class="ab-stats">
            <span class="ab-stat ab-stat-c" title="At Center">⌂ {{ book.available }}</span>
            <span class="ab-stat ab-stat-m" title="Issued">⇌ {{ book.issued }}</span>
          </div>
          <button class="ab-view-btn" (click)="openCopiesModal(book)">
            <i class="pe-7s-map-marker me-1"></i> View Copies
          </button>
        </div>
      </div>
    </div>

  </div>
</div>

<!-- ── Copies Modal (stacks over author books modal) ──────────────────────── -->
<div class="ab-cm-backdrop" *ngIf="showCopiesModal" (click)="closeCopiesModal()"></div>
<div class="ab-cm-modal" *ngIf="showCopiesModal" (click)="$event.stopPropagation()">

  <div class="ab-cm-header">
    <div class="ab-cm-title">
      <i class="pe-7s-map-marker me-2 text-primary"></i>Copy Locations
    </div>
    <button type="button" class="ab-close-btn" (click)="closeCopiesModal()">
      <i class="pe-7s-close"></i>
    </button>
  </div>

  <div class="ab-cm-book-strip">
    <div class="ab-cm-book-icon"><i class="pe-7s-notebook"></i></div>
    <div class="ab-cm-book-info">
      <div class="ab-cm-book-name">{{ selectedCopiesBook?.bookName }}</div>
      <div class="ab-cm-book-meta">
        <span class="ab-code" *ngIf="selectedCopiesBook?.bookId">{{ selectedCopiesBook.bookId }}</span>
        <span class="ab-cm-author" *ngIf="selectedCopiesBook?.authorNames?.length">
          {{ selectedCopiesBook.authorNames.join(', ') }}
        </span>
      </div>
    </div>
    <div class="ab-stats">
      <span class="ab-stat ab-stat-c" title="At Center">⌂ {{ selectedCopiesBook?.available }}</span>
      <span class="ab-stat ab-stat-m" title="Issued">⇌ {{ selectedCopiesBook?.issued }}</span>
      <span class="ab-stat ab-stat-t" title="Total">&#x2022; {{ selectedCopiesBook?.totalCopies }}</span>
    </div>
  </div>

  <div class="ab-cm-body">
    <div class="ab-no-copies text-muted small" *ngIf="!selectedCopiesBook?.copies?.length">
      No inventory copies found for this book.
    </div>
    <table class="table table-sm ab-cm-copies-table mb-0" *ngIf="selectedCopiesBook?.copies?.length">
      <thead>
        <tr><th>Sr No.</th><th>Status</th><th>Location</th></tr>
      </thead>
      <tbody>
        <tr *ngFor="let copy of selectedCopiesBook?.copies" [class]="authorBookRowClass(copy.status)">
          <td class="ab-srno">{{ copy.bookSrNo }}</td>
          <td>
            <span class="ab-status-badge" [ngClass]="'ab-badge-' + copy.status">
              {{ authorBookStatusLabel(copy.status) }}
            </span>
          </td>
          <td class="ab-location">{{ copy.location }}</td>
        </tr>
      </tbody>
    </table>
  </div>

</div>
